<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs :append="[editData.username]" />
          <info-menu :is-new="isNew" :read-only.sync="infoReadonly" />
          <div class="basic-information">
            <!-- 虚线验证在form 加 error-form ref="editDataForm":rules="rules"-->
            <el-form class="error-form basic-table basic-table-div" :disabled="isSnapshot">
              <el-collapse v-model="activeNames">

                <!--基本信息start-->
                <el-collapse-item title="基本信息" name="basicInfo">
                  <el-row>
                    <el-col :span="2"><span class="color-red">姓名</span></el-col>
                    <el-col :span="4">
                      <el-input :disabled="infoReadonly && !canEditByCreator" class="jm-input175" v-model="editData['username']" autofocus="autofocus" ref="username"/>
                    </el-col>
                    <el-col :span="2">昵称</el-col>
                    <el-col :span="4">
                      <el-input :disabled="infoReadonly && !canEditByCreator" class="jm-input175" v-model="editData['nickname']" />
                    </el-col>
                    <el-col :span="2">采集功能</el-col>
                    <el-col :span="4">
                      <el-select v-if="isNew" v-model="editData['create_point']" filterable class="jm-input175" clearable
                                 placeholder="请选择">
                        <el-option-group
                          v-for="(group, k) in ds.create_person"
                          :key="k"
                          :label="k">
                          <el-option
                            v-for="item in group"
                            v-if="item.userid < 0"
                            :key="item.userid"
                            :label="item.username"
                            :value="item.userid"/>
                        </el-option-group>
                      </el-select>
                      <span v-else>{{ editData.create_point_value }}</span>
                      <span v-if="!isNew">({{ editData.create_time }})</span>
                    </el-col>
                    <el-col :span="2">推广人</el-col>
                    <el-col :span="4">
                      <el-select v-if="isNew && isTrainingSite || $hasPermission([])" v-model="editData['custom_promoter']" filterable class="jm-input175" clearable
                                 placeholder="请选择">
                        <el-option-group
                          v-for="(group, k) in ds.create_person"
                          :key="k"
                          :label="k">
                          <el-option
                            v-for="item in group"
                            v-if="item.userid > 0"
                            :key="item.userid"
                            :label="item.username"
                            :value="item.userid"/>
                        </el-option-group>
                      </el-select>
                      <span v-else>{{ editData.custom_promoter_value }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2"><span class="color-red">电话</span></el-col>
                    <el-col :span="6" style="display: flex;align-items: center;">
                      <el-form-item prop="tel">
                        <!--3707105 唐博考培管理-->
                        <el-input
                          style="float:left"
                          ref="telInput"
                          :disabled="(infoReadonly && !canEditByCreator && isST) || (!isNew && $hasPermission(80, true) && !!originData['tel'])"
                          class="jm-input175"
                          @blur="checkTel"
                          v-model.trim="editData['tel']">
                        </el-input>

                        <template v-if="clinkAgentLogin && originData.tel" >
                          <el-button v-if="!clinkCallTime" size="small" style="height:36px" type="primary" @click="clinkOutcall(originData.tel)">
                            <i class="el-icon-phone" />
                          </el-button>
                          <el-button v-else size="small" style="height:36px" type="success" @click="clinkOutcallCancel()">
                            {{ clinkFormattedCallTime }} &nbsp; <i class="el-icon-error" />
                          </el-button>
                        </template>
                        <!--百应外呼-->
                        <template v-if="originData.tel && false" >
                          <el-button size="small" style="height:36px;" type="success" @click="outCallXmy(originData.tel)">
                            <i class="el-icon-phone" />
                          </el-button>
                        </template>
                        <span style="display:inline-block;vertical-align: top;">
                          <!--点控云外呼-->
                          <template v-if="originData.tel">
                            <router-link target="_blank" :to="{ name: 'dky', params: { id: editData.id } }">
                              <el-button size="small" style="height:36px;" type="success"><i class="el-icon-phone"/></el-button>
                            </router-link>
                          </template>
                          <Copy
                            style="float:left"
                            v-if="(infoReadonly && !canEditByCreator) || (!isNew && $hasPermission(80, true) && !!originData['tel'])"
                            :content="editData.tel"
                            @copyCallback="copyClick()">
                            <el-button size="small" style="height:36px">复制</el-button>
                          </Copy>
                        </span>
                        <el-button type="text" v-if="editData.crm_tel_province || editData.crm_tel_city">
                          &nbsp; 归属地区：{{ editData.crm_tel_province }} {{ editData.crm_tel_city }}
                        </el-button>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1">QQ</el-col>
                    <el-col :span="3">
                      <el-form-item prop="qq">
                        <el-input
                          :disabled="(infoReadonly && !canEditByCreator) || (!isNew && $hasPermission(80, true) && !!originData['qq'])"
                          class="jm-input175"
                          :maxlength="20"
                          v-model.trim="editData['qq']">
                          <!-- <el-button slot="append">x</el-button> -->
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="2">微信</el-col>
                    <el-col :span="4">
                      <el-form-item prop="wechat">
                        <el-input
                          style="float:left"
                          :disabled="(infoReadonly && !canEditByCreator && isST) || (!isNew && $hasPermission(80, true) && !!originData['wechat'])"
                          class="jm-input175"
                          v-model.trim="editData['wechat']" />
                        <Copy
                          style="float:left"
                          v-if="(infoReadonly && !canEditByCreator) || (!isNew && $hasPermission(80, true) && !!originData['wechat'])"
                          :content="editData.wechat"
                          @copyCallback="copyClick()">
                          <el-button size="small" style="height:36px">复制</el-button>
                        </Copy>
                      </el-form-item>
                    </el-col>
                    <el-col :span="2"><span class="color-red">性别</span></el-col>
                    <el-col :span="4">
                      <jm-dict-select :disabled="infoReadonly && !canEditByCreator" class="jm-input175" clearable v-model="editData['gender']" dict="dataset.student.gender" ref="gender"/>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">是否已添加微信</el-col>
                    <el-col :span="6" style="justify-content: flex-start">
                      <el-switch
                        active-text="是"
                        inactive-text="否"
                        active-value="1"
                        inactive-value="0"
                        v-model="editData['take_wechat']"/>
                    </el-col>
                    <el-col :span="2">是否主动添加</el-col>
                    <el-col :span="6" style="justify-content: flex-start">
                      <el-switch
                        active-text="是"
                        inactive-text="否"
                        active-value="1"
                        inactive-value="0"
                        v-model="editData['hand']"/>
                    </el-col>
                    <el-col :span="2">销售进程</el-col>
                    <el-col :span="6">
                      <jm-dict-select v-model="editData['sale_proc']" class="jm-input220" clearable type="dataset" dict-type="training" name="saleProc" :disabled="true"/>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">渠道来源</el-col>
                    <el-col :span="14">
                      <jm-channel ref="channelRef" :disabled="!$hasPermission(1) && !isNew" v-if="isTrainingSite" :exclude-disable="!$hasPermission(1) && !isNew" :is-all="false" :final.sync="channelFinal" v-model="channelModel" clearable filter />
                      <template v-else>
                        {{ editData.channelsData }}
                      </template>
                    </el-col>
                    <el-col :span="2">意向部门</el-col>
                    <el-col :span="6">
                      <div style="float:left;">
                        <el-checkbox-group v-model="editData['target_country']" ref="targetCountryRef" :disabled="infoReadonly">
                          <el-checkbox label="1868">考培</el-checkbox>
                          <!-- <el-checkbox label="2044" disabled>英澳培训</el-checkbox> -->
                          <!-- <el-checkbox label="1944" disabled>高考日语线上</el-checkbox> -->
                          <!-- <el-checkbox label="2043" disabled>高考日语线下</el-checkbox> -->
                        </el-checkbox-group>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">线索画像</el-col>
                    <el-col :span="16">
                      <template v-if="editData['nseries_tags']">
                        <el-tag style="margin-left: 10px;" effect="dark" v-if="editData['nseries_tags']['jp_purpose']" type="danger">学习目的 {{ editData['nseries_tags']['jp_purpose'] }}</el-tag>
                        <el-tag style="margin-left: 10px;" effect="dark" v-if="editData['nseries_tags']['social_identity']" type="danger">用户身份 {{ editData['nseries_tags']['social_identity'] }}</el-tag>
                        <el-tag style="margin-left: 10px;" effect="dark" v-if="editData['nseries_tags']['level_now']" type="danger">当前等级 {{ editData['nseries_tags']['level_now'] }}</el-tag>
                        <el-tag style="margin-left: 10px;" effect="dark" v-if="editData['nseries_tags']['level_target']" type="danger">需达到等级 {{ editData['nseries_tags']['level_target'] }}</el-tag>
                        <el-tag style="margin-left: 10px;" effect="dark" v-if="editData['nseries_tags']['area']" type="danger">{{ editData['nseries_tags']['area'] }}</el-tag>
                        <el-tag style="margin-left: 10px;" effect="dark" v-if="editData['nseries_tags']['mobile_brand']" type="danger">机型 {{ editData['nseries_tags']['mobile_brand'] }}</el-tag>
                        <el-tag style="margin-left: 10px;" effect="dark" v-if="editData['nseries_tags']['date_time']" type="danger">App注册时间 {{ editData['nseries_tags']['date_time'] }}</el-tag>
                      </template>
                    </el-col>
                    <el-col :span="2">AI外呼反馈</el-col>
                    <el-col :span="4" style="justify-content: left">
                      <el-tag effect="dark" type="danger">{{ editData['ai_tag_str'] }}</el-tag>
                      &nbsp; &nbsp;{{ editData['ai_tag_time'] }}
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">备注</el-col>
                    <el-col :span="22">
                      <el-input class="training-memo" type="textarea" :rows="2" placeholder="请输入备注" v-model="editData['memo']" :disabled="infoReadonly"/>
                    </el-col>
                  </el-row>
                  <el-row v-if="editData['sync'] && editData['sync'].length >= 1">
                    <el-col>
                      <div class="red">
                        <p v-for="(sync, k) in editData['sync']" :key="k">【资源内推{{ sync.create_time }}】{{ sync.sender_department }}-{{ sync.sender }}老师给您留言：{{ sync.note }}</p>
                      </div>
                    </el-col>
                  </el-row>
                </el-collapse-item>
                <!--基本信息end-->

                <!--语言信息start-->
                <el-collapse-item title="语言信息" name="language">
                  <el-row>
                    <el-col :span="2">意向语言</el-col>
                    <el-col :span="22">
                      <div style="float:left;">
                        <el-checkbox-group v-model="editData['target_lan']" :disabled="infoReadonly /* */">
                          <el-checkbox label="日语" native></el-checkbox>
                          <el-checkbox label="韩语" native></el-checkbox>
                          <el-checkbox label="雅思" native></el-checkbox>
                          <el-checkbox label="托福" native></el-checkbox>
                          <el-checkbox label="托业" native></el-checkbox>
                          <el-checkbox label="EJU" native></el-checkbox>
                          <el-checkbox label="修士" native></el-checkbox>
                          <el-checkbox label="预科" native></el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </el-col>
                  </el-row>
                </el-collapse-item>
                <!--语言信息end-->

                <!--学员信息start-->
                <el-collapse-item title="学员信息" name="userInfo">
                  <el-row>
                    <el-col :span="2"><span class="color-red">用户身份</span></el-col>
                    <el-col :span="6">
                      <jm-identity-select clearable v-model="editData['identity']" :disabled="infoReadonly" ref="identity"/>
                    </el-col>
                    <el-col :span="2"><span class="color-red">学习动机</span></el-col>
                    <el-col :span="6">
                      <!--<jm-dict-select v-model="editData['study_motive']" class="jm-input220" clearable type="dataset" dict-type="training" name="learningMotivation" :disabled="infoReadonly" ref="studyMotive"/>-->
                      <jm-dict-select :disabled="infoReadonly" class="jm-input220" clearable v-model="editData['study_motive']" dict="dataset.training.learningMotivation" ref="studyMotive"/>
                    </el-col>
                    <el-col :span="2">是否有报课意向</el-col>
                    <el-col :span="6">
                      <el-switch
                        active-text="是"
                        inactive-text="否"
                        active-value="1"
                        inactive-value="0"
                        v-model="editData['has_intention']"/>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2"><span class="color-red">语言基础</span></el-col>
                    <el-col :span="6">
                      <el-input v-model="editData['language_foundation']" class="jm-input220" :disabled="infoReadonly" ref="languageFoundation"/>
                    </el-col>
                    <el-col :span="2">学习目标</el-col>
                    <el-col :span="6">
                      <el-input v-model="editData['study_goal']" class="jm-input220" :disabled="infoReadonly"/>
                    </el-col>
                    <el-col :span="2">计划考试时间</el-col>
                    <el-col :span="6">
                      <el-date-picker
                        v-model="editData['exam_date']"
                        value-format="yyyy-MM"
                        type="month"
                        placeholder="请选择">
                      </el-date-picker>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">选择科目</el-col>
                    <el-col :span="6">
                      <!--<jm-dict-select v-model="editData['study_subject']" class="jm-input220" clearable type="dataset" dict-type="training" name="studySubject" :disabled="infoReadonly"/>-->
                      <jm-dict-select :disabled="infoReadonly" class="jm-input220" clearable v-model="editData['study_subject']" dict="dataset.training.studySubject"/>
                    </el-col>
                    <el-col :span="2">计划入学时间</el-col>
                    <el-col :span="6">
                      <el-date-picker
                        v-model="editData['plan_date']"
                        value-format="yyyy-MM"
                        type="month"
                        placeholder="请选择">
                      </el-date-picker>
                    </el-col>
                    <el-col :span="2">修士意向升学方式</el-col>
                    <el-col :span="6">
                      <!--<jm-dict-select v-model="editData['higher_way']" class="jm-input220" clearable type="dataset" dict-type="training" name="higherWay" :disabled="infoReadonly"/>-->
                      <jm-dict-select :disabled="infoReadonly" class="jm-input220" clearable v-model="editData['higher_way']" dict="dataset.training.higherWay"/>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">就读学校</el-col>
                    <el-col :span="6">
                      <el-input class="jm-input220" v-model="editData['school_name']" :disabled="infoReadonly" />
                    </el-col>
                    <el-col :span="2">就读专业</el-col>
                    <el-col :span="6">
                      <el-input class="jm-input220" v-model="editData['edu_major_name']" :disabled="infoReadonly" />
                    </el-col>
                    <el-col :span="2">推荐课程</el-col>
                    <el-col :span="6">
                      <el-input v-model="editData['recommend_lesson']" class="jm-input220" :disabled="infoReadonly"/>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">目标学校</el-col>
                    <el-col :span="6">
                      <el-input class="jm-input220" v-model="editData['target_school']" :disabled="infoReadonly" />
                    </el-col>
                    <el-col :span="2">目标专业</el-col>
                    <el-col :span="6">
                      <el-input class="jm-input220" v-model="editData['target_major']" :disabled="infoReadonly" />
                    </el-col>
                    <el-col :span="2"></el-col>
                    <el-col :span="6"></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2"><span class="color-red">所在城市</span></el-col>
                    <el-col :span="6">
                      <el-input v-model="editData['current_city']" class="jm-input220" :disabled="infoReadonly" ref="currentCity"/>
                    </el-col>
                    <el-col :span="2">邮寄地址</el-col>
                    <el-col :span="6">
                      <el-form-item prop="post_address">
                        <el-input class="jm-input220" v-model.trim="editData['post_address']" :disabled="infoReadonly" />
                      </el-form-item>
                    </el-col>
                  </el-row>

                </el-collapse-item>
                <!--学员信息end-->

                <!--签约信息start-->
                <el-collapse-item title="签约信息" name="signInfo" :disabled="infoReadonly">
                  <el-row>
                    <el-col :span="2">
                      <template>客户状态</template>
                    </el-col>
                    <el-col :span="6">
                      <jm-dict-select
                        clearable type="dataset" dict-type="training" :disabled="infoReadonly /* */" class="jm-input175"
                        name="trainingLevelType" v-model="editData['customer_status']" :filter="isSayer"/>
                      <jm-dict-select v-model="editData['diff_type']" class="jm-input175" clearable type="dataset" dict-type="training" name="diffType" :disabled="infoReadonly" v-if="followpUp"/>
                      <el-input v-model="editData['diff_other']" class="jm-input175" :disabled="infoReadonly" style="margin-left: 6px" v-if="followpUp && otherDiff"/>
                    </el-col>
                    <el-col :span="2"><span class="color-red">签约日期</span></el-col>
                    <el-col :span="3">
                      <el-date-picker v-model="editData['sign_date']" class="jm-input175" format="yyyy-MM-dd" :disabled="infoReadonly"
                                      value-format="yyyy-MM-dd" type="date" ref="signData" placeholder="选择日期" />
                    </el-col>
                    <el-col :span="2"><span class="color-red">合同截至日期</span></el-col>
                    <el-col :span="3">
                      <el-date-picker v-model="editData['contract_expiration_date']"
                                      class="jm-input175" format="yyyy-MM-dd" :disabled="infoReadonly"
                                      value-format="yyyy-MM-dd" type="date" ref="contractExpirationDate" placeholder="选择日期" />
                    </el-col>
                    <el-col :span="2">意向分级</el-col>
                    <el-col :span="4">
                      <jm-dict-select v-model="editData['customer_classify']" class="jm-input135" type="dataset"
                                      dict-type="training" name="trainingLvType" :disabled="infoReadonly && notEditTrainingLvType" />
                      <el-tooltip placement="top">
                        <div slot="content">
                          A：高意向，预计近一两天成交；<br>
                          B：中高意向，预计周内成交；<br>
                          C：介绍完课程，预计月内成交；<br>
                          D：介绍完课程，暂时无购课意向；<br>
                          E：与线索没有握上手；
                        </div>
                        <el-button type="primary" circle style="width: 20px;height:20px;text-align: center;font-weight: bold;font-size: 12px;padding: 0;margin-left: 5px;">?</el-button>
                      </el-tooltip>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2"><span class="color-red">咨询老师</span></el-col>
                    <el-col :span="6">
                      <el-select
                        v-model="editData['training_teacher']"
                        :disabled="teacherModifyDisable"
                        class="jm-input175"
                        filterable
                        placeholder="请选择">
                        <el-option-group
                          v-for="(group, k) in trainingTeachers"
                          :key="k"
                          :label="k">
                          <el-option
                            v-for="(item,k1) in group"
                            :key="k1"
                            :label="item.truename"
                            :value="item.userid"/>
                        </el-option-group>
                      </el-select>
                      &nbsp;分配时间：{{ editData['change_teacher_time'] }}
                    </el-col>
                    <el-col :span="2"><span class="color-red">签约金额</span></el-col>
                    <el-col :span="3">
                      <el-input class="jm-input175" v-model="editData['contracted_money']" :disabled="infoReadonly" ref="contracted_money" type="number" clearable/>
                    </el-col>
                    <el-col :span="2"><span class="color-red">是否全款缴齐</span></el-col>
                    <el-col :span="3" style="justify-content: flex-start">
                      <el-switch
                        active-text="是"
                        inactive-text="否"
                        active-value="1"
                        inactive-value="0"
                        v-model="editData['is_fullpay']"/>
                    </el-col>
                    <el-col :span="2">留学咨询老师</el-col>
                    <el-col :span="4">
                      <el-input class="jm-input175" v-model="editData['crm_sayer_name']" :disabled="true" />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">用户运营老师</el-col>
                    <el-col :span="6">
                      <el-select
                        v-model="editData['op_teacher']"
                        class="jm-input175"
                        filterable
                        placeholder="请选择">
                        <el-option
                          label="未分配"
                          :value="0"
                        />
                        <el-option-group
                          v-for="(group, k) in opTeachers"
                          :key="k"
                          :label="k">
                          <el-option
                            v-for="item in group"
                            :key="item.userid"
                            :label="item.truename"
                            :value="item.userid"/>
                        </el-option-group>
                      </el-select>
                      &nbsp;分配时间：{{ editData['op_createtime_fix'] }}
                    </el-col>
                    <el-col :span="2"><span class="color-red">签约课程班级</span></el-col>
                    <el-col :span="3">
                      <el-input class="jm-input220" v-model="editData['course_class']" placeholder="" ref="course_class" clearable/>
                    </el-col>
                    <el-col :span="2">开课日期</el-col>
                    <el-col :span="3">
                      <el-date-picker v-model="editData['course_start_date']" class="jm-input175" format="yyyy-MM-dd" :disabled="infoReadonly" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
                    </el-col>
                    <el-col :span="2">预计结课日期</el-col>
                    <el-col :span="4">
                      <el-date-picker v-model="editData['course_end_date']" class="jm-input175" format="yyyy-MM-dd" :disabled="infoReadonly" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2"><span class="color-red">教务老师</span></el-col>
                    <el-col :span="6">
                      <el-select
                        v-model="editData['jw_teacher']"
                        class="jm-input175"
                        filterable
                        clearable
                        ref="jw_teacher"
                        placeholder="请选择">
                        <el-option
                          label="未分配"
                          :value="0"
                        />
                        <el-option-group
                          v-for="(group, k) in jwTeachers"
                          :key="k"
                          :label="k">
                          <el-option
                            v-for="item in group"
                            :key="item.userid"
                            :label="item.truename"
                            :value="item.userid"/>
                        </el-option-group>
                      </el-select>
                    </el-col>
                    <el-col :span="2">介绍人编码</el-col>
                    <el-col :span="3">
                      <el-input class="jm-input175" v-model="editData['introducer_id']" :disabled="canEditIntroducerId" placeholder="填写本系统的资源编码" ref="introducer_id"/>
                    </el-col>
                    <el-col :span="2"><span class="color-red">缴费截图</span></el-col>
                    <el-col :span="3">
                      <jm-upload
                        :show-file-list="false"
                        action="/newfib.php/index/api_base/uploadSimpleFile/type/payimg"
                        :on-success="uploadPayImgSuccess"
                      >
                        <slot>
                          <el-button type="warning" size="small">上传截图</el-button>
                        </slot>
                      </jm-upload>
                      <el-button v-show="editData['pay_img']" @click="downloadPayImg" size="small" class="left10">
                        下载截图
                      </el-button>
                    </el-col>
                    <el-col :span="2">介绍人姓名</el-col>
                    <el-col :span="4">
                      <el-input class="jm-input175" v-model="editData['introducer_name']" :disabled="true" placeholder="" />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2"><span class="color-red">其他交接备注</span></el-col>
                    <el-col :span="22">
                      <el-input class="training-memo1" type="textarea" :rows="2" placeholder="无需备注可以写【无】" v-model="editData['other_handover_remarks']" :disabled="infoReadonly" ref="other_handover_remarks"/>
                    </el-col>
                  </el-row>
                </el-collapse-item>
                <!--签约信息end-->

              </el-collapse>

              <!--按钮start-->
              <!-- 2395902 ：考级用户运营，106：考培助理总监 89：数据分析专员 160：考培组长，117 用户运营-->
              <div class="basic-buttom"
                   v-if="userInfo.userid === 2395902 || (isTrainingSite && !infoReadonly && !$hasPermission(106, true) && !$hasPermission(89, true))|| $hasPermission([160,117,174], true)">
                <el-button type="success" :loading="saving" @click="save()">保存</el-button>
                <!-- <el-button type="primary" :loading="saving" @click="save(true)">保存并新建</el-button> -->
                <template v-if="!isNew && isTrainingSite && $hasPermission([80, 85, 91, 92])">
                  <el-button type="danger" v-if="!syncDialog.finished" @click="showSyncDialog">同步到其他系统</el-button>
                  <el-button type="success" v-if="syncDialog.linked" @click="showSyncMsgDialog">资源动态提醒</el-button>
                </template>
              </div>
              <!--按钮end-->
            </el-form>
          </div>
          <div v-if="!isNew && !isSnapshot">
            <visit
              title="预约试听"
              :user-id="$route.params.id"
              :data-url="`/training/booking/paginate/userid/${$route.params.id}`"
              delete-url="/training/booking/resource/id"
              type="listenOperate"
              :btn-opt-permission="canEditByCreator || $hasPermission([155, 91,85]) || true"
              :table-opt-permission="!infoReadonly || this.$hasPermission([155, 91,85])"
              :jw_teacher = "editData.jw_teacher"
              :username = "editData.username"
              :tel = "editData.tel"
            />
            <visit
              title="学生回访"
              :user-id="$route.params.id"
              :data-url="`/training/visit/paginate/userid/${$route.params.id}`"
              delete-url="/training/visit/resource/id"
              type="training"
              :btn-opt-permission="!infoReadonly || this.$hasPermission([117,97])"
            />
            <visit
              title="运营回访"
              :user-id="$route.params.id"
              :data-url="`/training/operate_visit/paginate/userid/${$route.params.id}`"
              delete-url="/training/operate_visit/resource/id"
              type="trainingOperate"
              :btn-opt-permission="$hasPermission([117, 84])"
              :table-opt-permission="!infoReadonly || this.$hasPermission(117)"
            />
            <visit
              title="教务回访"
              :user-id="$route.params.id"
              :data-url="`/training/jw_visit/paginate/userid/${$route.params.id}`"
              delete-url="/training/jw_visit/resource/id"
              type="trainingJw"
              :btn-opt-permission="!infoReadonly"
              :table-opt-permission="!infoReadonly"
            />
          </div>
          <div v-if="!isNew && isTrainingSite">
            <div class="bind">
              活动记录
            </div>
            <jm-tableList
              url="/training/customer/showActivityLog"
              :search-data="{userid: $route.params.id}"
              row-key="id"
            >
            </jm-tableList>
          </div>
        </div>
      </div>
    </div>
    <!--106 考培助理总监 89数据分析专员 160考培组长 174考培咨询客服-->
    <el-button
      v-if="!infoReadonly && !$hasPermission(106, true) && !$hasPermission(89, true) || $hasPermission(160, true)"
      class="edit-fixed"
      type="success"
      size="mini"
      :loading="saving"
      @click="save()">保存</el-button>

    <sync-dialogs
      v-if="isTrainingSite"
      @confirm="doSync"
      @loaded="syncDataLoaded"
      :type="syncType"
      width="30%"
      :from="editData.id"
      :visible.sync="syncDialogVisible">
    </sync-dialogs>
    <view-large-image :visible.sync="viewImageLock" :img-url="reuseImage"></view-large-image>
  </div>
</template>

<script>
import tableList from '@/components/data/tableList';
import alertTransfer from '@/components/tool/alertTransfer';
import alertText from '@/components/tool/alertText';
import syncDialogsMixin from '@/components/syncDialogsMixin';
import { CREATOR_TRAINING_TO_FIB, CREATOR_TRAINING_TO_JOB } from '@/const/sync';
import {
  jmAreaselect,
  jmChannel,
  jmEducationSelect,
  jmLessonSelect,
  jmDictSelect,
  jmUploadFile,
  jmExamjpSelect,
  jmStudytargetSelect,
  jmIdentitySelect,
} from '@/components/tool';
import '@/assets/jsmind/js/jsmind.js';
import '@/assets/jsmind/style/jsmind.css';
import studentMixin from '@/pages/student/student.js';
import {
  deepClone,
  delay
} from '@/utils/utils';
import customerApi from '@/training/api/customer';
import infoMenu from '@/components/infoMenu';
import viewLargeImage from '@/components/pop/viewLargeImage';
import ElOption from 'element-ui/packages/select/src/option';

const ClinkAgent = window.ClinkAgent;
const visit = () => import('@/components/visit');

export default {
  mixins: [studentMixin, syncDialogsMixin],
  components: {
    ElOption,
    'jm-tableList': tableList,
    'jm-alertTransfer': alertTransfer,
    'jm-alertText': alertText,
    jmChannel,
    jmAreaselect,
    jmEducationSelect,
    jmIdentitySelect,
    jmLessonSelect,
    jmDictSelect,
    jmUploadFile,
    jmExamjpSelect,
    jmStudytargetSelect,
    infoMenu,
    visit,
    viewLargeImage
  },
  beforeRouteEnter(to, from, next) {
    if (to.meta.isNew) {
      next((vm) => {
        vm.setNewCustomerData();
      });
      return true;
    }

    const customerId = to.params.customer_id || to.params.id;
    // 如果是重复资源记录
    if (to.name === 'resourceSnapshot') {
      customerApi.getSnapshotById(customerId).then(({
        data
      }) => {
        next((vm) => {
          vm.setCustomerInfo(data);
          vm.setIsSnapshot(true);
        });
      });
    } else {
      customerApi.getCustomerById(customerId).then(({
        data
      }) => {
        next((vm) => {
          vm.setCustomerInfo(data);
        });
      })
        .catch(() => {
          this.$router.replace({ name: 'resourceManage' });
        });
    }
  },
  data() {
    return {
      clinkAgentLogin: false, // Clink 外呼系统登录状态
      clinkCallTime: 0, // 外呼时间
      clinkTimerId: null, // 定时器
      syncConfirmVisible: false, // 同步资源对话框
      pushMessageFormVisible: false, // 资源动态提醒对话框
      existsInFib: false, // 蓝火内是否已经有相同手机号
      refresh: false,
      saving: false,
      followpUp: false, // 是否跟进
      otherDiff: false, // 其他异议
      channelModel: {}, // 渠道信息
      activeNames: [
        'basicInfo',
        'signInfo',
        'language',
        'userInfo'
      ],
      ds: {},
      editData: {
        id: 0,
        customer_status: 13,
        training_teacher: -1,
        education: [],
        study_goal: [],
        study_goal_kr: [],
        target_lan: [],
        target_country: [],
        recommend_lesson_en: '',
        hand: 0,
        op_createtime_fix: '',
        customer_classify: 0,
        jw_teacher: '',
        identity: ['', ''],
        pay_img: '',
      },
      originData: {
        tel: '',
        qq: '',
        wechat: ''
      },
      isSnapshot: false, // 是否为重复资源快照
      isNew: false,
      isEdit: true,
      siteIndex: '1',
      channelFinal: false,
      siteName: process.env.VUE_APP_SITE_NAME,
      viewImageLock: false,
      reuseImage: ''
    };
  },
  methods: {
    viewBigImg(url) {
      if (url) {
        this.reuseImage = url;
        this.viewImageLock = true;
      } else {
        this.$message.error('图片路径错误');
      }
    },
    resetEditData() {
      this.isNew = true;
      this.editData = {
        customer_status: 13, // 等待处理
        target_lan: [],
        target_country: [],
        training_teacher: Number(this.userInfo.userid),
      };
    },
    /**
     * 查看缴费截图
     */
    downloadPayImg() {
      window.open(this.$jiemo.imghome + this.editData.pay_img);
    },
    /**
     * 上传缴费截图
     */
    uploadPayImgSuccess({ msg, result, data }) {
      if (result === -1) {
        this.$message.error(msg);
        return false;
      }
      this.$message.success('缴费截图上传成功');
      this.editData.pay_img = data.path;
    },
    /**
     * 保存
     */
    save(isNew = false, showNotify = true) {
      if (!this.hasContactInfo(this.editData.tel, this.editData.wechat)) {
        if (this.editData.id && !this.hasContactInfo(this.editData.qq)) {
          this.$message.error('请填写联系方式');
          this.$refs.telInput.focus();
          return false;
        }
        if (!this.editData.id) {
          this.$message.error('必须填写微信或手机号');
          this.$refs.telInput.focus();
          return false;
        }
      }

      if (this.editData.qq && !this.editData.qq.match(/^\d{5,}$/)) {
        this.$message.error('QQ号码格式错误');
        return false;
      }

      if (!this.hasTargetCountry(this.editData.target_country)) {
        this.$message.error('意向部门至少填写一项');
        // this.$refs.targetCountryRef.focus();
        return false;
      }

      if (!this.hasChannel(this.channelModel)) {
        this.$message.error('渠道来源必须填写');
        this.$refs.channelRef.focus();
        return false;
      } else if (!this.channelFinal) {
        this.$message.error('渠道来源必须填写完全');
        return Promise.reject(new Error('渠道来源必须填写完全'));
      }
      // 已报名必填规则
      if (this.editData.customer_status === 7) {
        if (!this.editData.username) {
          this.$message.error('请填写姓名');
          this.$refs.username.focus();
          return false;
        }
        if (!this.editData.gender) {
          this.$message.error('请填写性别');
          this.$refs.gender.focus();
          return false;
        }
        if (this.editData.identity[0] === '0') {
          this.$message.error('请填写用户身份');
          this.$refs.identity.focus();
          return false;
        }
        if (!this.editData.study_motive) {
          this.$message.error('请填写学习动机');
          this.$refs.studyMotive.focus();
          return false;
        }
        if (!this.editData.language_foundation) {
          this.$message.error('请填写语言基础');
          this.$refs.languageFoundation.focus();
          return false;
        }
        if (!this.editData.current_city) {
          this.$message.error('请填写所在城市');
          this.$refs.currentCity.focus();
          return false;
        }
        if (!this.editData.sign_date) {
          this.$message.error('请填写签约日期');
          this.$refs.signData.focus();
          return false;
        }
        if (!this.editData.contract_expiration_date) {
          this.$message.error('请填写合同截至日期');
          this.$refs.contractExpirationDate.focus();
          return false;
        }
        if (!this.editData.contracted_money) {
          this.$message.error('请填写签约金额');
          this.$refs.contracted_money.focus();
          return false;
        }
        if (!this.editData.course_class) {
          this.$message.error('请填签约课程班级');
          this.$refs.course_class.focus();
          return false;
        }
        if (!this.editData.jw_teacher) {
          this.$message.error('请选择教务老师');
          this.$refs.jw_teacher.focus();
          return false;
        }
        if (!this.editData.pay_img) {
          this.$message.error('请上传缴费截图');
          return false;
        }
        if (!this.editData.other_handover_remarks) {
          this.$message.error('请填写其他交接备注');
          this.$refs.other_handover_remarks.focus();
          return false;
        }
      }

      if (this.isNew === false && this.editData.customer_classify < 50) {
        this.$message.error('请选择意向分级');
        return false;
      }

      // 客户状态改为已签约时，教务老师必须选择，不能为空,顾问填写
      if (this.editData.customer_status === 7 && !this.editData.jw_teacher) {
        this.$message.error('请选择教务老师');
        this.$refs.jw_teacher.focus();
        return false;
      }

      // 渠道来源是 直访与转介(7106)-转介绍(7109)-学生介绍(7878) 必须填写介绍人编码
      if (this.editData.custom_from_thrid === 7878 && !this.editData.introducer_id) {
        this.$message.error('请填写介绍人编码');
        this.$refs.introducer_id.focus();
        return false;
      }

      this.saving = true;
      return new Promise((resolve, reject) => {
        this.$http._post({
          url: '/training/customer/resource',
          data: this.getData4Save(),
        }).then(({ data }) => {
          this.saving = false;
          if (data === 1) {
            showNotify && this.$message.success('保存成功');
          }
          if (isNew || this.isNew) {
            delay(1).then(() => {
              this.$router.push({
                name: 'addCustomer'
              });
              this.resetEditData();
            });
          }
          resolve(data);
        }, ({ data }) => {
          this.saving = false;
          resolve(data);
        }).catch((e) => {
          this.saving = false;
          reject(e);
        });
      });
    },
    setIsSnapshot: function(bool) {
      this.isSnapshot = bool;
    },
    /**
     * 填充学员信息
     *
     * @param {Object} data
     */
    setCustomerInfo(data) {
      // 渠道
      this.channelModel = {
        custom_from: data.custom_from || null,
        custom_from_sub: data.custom_from_sub || null,
        custom_from_thrid: data.custom_from_thrid || null,
        custom_from_fourth: data.custom_from_fourth || null,
        custom_from_fifth: data.custom_from_fifth || null,
      };
      // 意向语言
      if (!data.target_lan) {
        data.target_lan = [''];
      }
      // 用户身份
      data.identity = [data.user_identity, data.identity_detail];
      this.editData = data;
      // 原始数据
      this.originData.tel = this.editData.tel || null;
      this.originData.qq = this.editData.qq || null;
      this.originData.wechat = this.editData.wechat || null;
    },

    /**
     * 同步到蓝火，填写信息
     * @param {Number} id
     */
    async syncToFib(id, message, to) {
      await this.$http._post({
        url: '/training/customer/syncToFib',
        data: { id, message, to }
      });
    },
    async syncToJob(id, message) {
      await this.$http._post({
        url: '/training/customer/syncToJob',
        data: { id, message }
      });
    },

    /**
     * 销盟云(百应)外呼
     */
    async outCallXmy(tel) {
      let data = await this.$http._post({
        url: '/training/xiao_meng_yun/makeCall',
        data: { tel }
      });
      this.$message.success(data.msg);
    },

    /**
     * 确认同步
     */
    async doSync({ system, message, to }) {
      const id = this.editData.id;
      if (system === CREATOR_TRAINING_TO_FIB) {
        await this.syncToFib(id, message, to);
      }

      if (system === CREATOR_TRAINING_TO_JOB) {
        await this.syncToJob(id, message);
      }
      this.$message.success('同步成功！');
      this.hideSyncDialog();
    },
    /**
     * 验证手机号码
     */
    checkTel(event) {
      let value = event.target.value.trim();
      if (value) {
        if (!this.checkMobile(value)) {
          this.$message.error('手机号码填写错误！');
          return false;
        }
        this.editData.tel = value;
      }
    },
    setNewCustomerData() {
      this.isNew = true;
      this.editData.creator = this.userInfo.userid;
      this.editData.create_point = -288;
      this.editData.custom_promoter = this.userInfo.userid;
    },
    syncDataLoaded(data) {
      this.syncDialog = data;
    },
    /**
     * 意向部门是否填写
     * @param {Object} targetCountry
     * @returns {Boolean}
     */
    hasTargetCountry(targetCountry) {
      return Object.values(targetCountry).some((item) => {
        return item;
      });
    },
    /**
     * 保存的数据
     */
    getData4Save() {
      let data = deepClone(this.editData);
      // 渠道
      data = Object.assign(data, this.channelModel);
      // 用户身份
      if (data.identity.length > 0) {
        [data.user_identity, data.identity_detail] = data.identity;
      }
      delete data.identity;
      delete data.visit_count;
      delete data.visit_time;
      return data;
    },
    // 复制点击
    copyClick() {
      this.$message.success('复制成功');
    },
    // 外呼定时器
    clinkTimer(act) {
      if (act === 'start' && !this.clinkTimerId) {
        this.clinkTimerId = setInterval(() => {
          this.clinkCallTime++;
        }, 1000);
      }

      if (act === 'stop' && this.clinkTimerId !== null) {
        clearInterval(this.clinkTimerId);
        this.clinkCallTime = 0;
        this.clinkTimerId = null;
      }
    },
    // 外呼电话
    clinkOutcall(tel) {
      // 判断如果为日本电话号码，改为 0081 开头的格式
      if (/^0(7|8|9)0\d{8}$/.test(tel)) {
        tel = tel.replace(/^0/, '0081');
      }
      // 外呼
      ClinkAgent.previewOutcall({
        tel: tel
      });
    },
    clinkOutcallCancel() {
      ClinkAgent.previewOutcallCancel();
    },
    /**
     * 判断目标语言是否包含给定数组中的任意元素
     * @param {Array} arr - 需要检测的语言标签数组
     * @returns {Boolean} 包含任一元素返回true，否则返回false
     */
    targetLanExist(arr) {
      if (!this.editData.target_lan || this.editData.target_lan.length === 0) {
        return false;
      }
      return arr.some(item => this.editData.target_lan.includes(item));
    },
    // clinkAgent 初始化
    initClinkAgent(bindTel, agentToken) {
      ClinkAgent.setup({ sipPhone: true, debug: false }, () => {
        // 注册登录响应回调方法
        ClinkAgent.registerCallback(ClinkAgent.ResponseType.LOGIN, (result) => {
          if (result.code === 0) {
            // 登录成功 result.data.agent.bindTel
            this.$message.info(`外呼系统（分机号${bindTel}）登录成功`);
            this.clinkAgentLogin = true;
          } else {
            // 登录失败
            this.$message.error(result.msg);
            this.clinkAgentLogin = false;
            console.error(result);
          }
        });
        // 预览外呼
        ClinkAgent.registerCallback(ClinkAgent.ResponseType.PREVIEW_OUTCALL, (result) => {
          console.log(result);
          if (result.code === 0) {
            // 外呼成功
            this.clinkTimer('start');
            this.$message.info('外呼成功');
          } else {
            // 外呼失败
            this.$message.error(`外呼失败：${result.msg}`);
            console.error(result);
          }
        });
        // 预览外呼取消
        ClinkAgent.registerCallback(ClinkAgent.ResponseType.PREVIEW_OUTCALL_CANCEL, (result) => {
          console.log(result);
          if (result.code === 0) {
            // 外呼成功
            this.clinkTimer('stop');
            this.$message.info('外呼已取消');
          } else {
            // 外呼失败
            this.$message.error(`外呼取消失败：${result.msg}`);
            console.error(result);
          }
        });

        // 登录接口
        ClinkAgent.login({
          identifier: 'jm1231',
          agentToken: agentToken,
          agentTokenLogin: 1,
          bindTel: bindTel,
          bindType: 3,
          loginStatus: 1
        });
      });
    },
    // 咨询老师不可放弃资源
    isSayer(item) {
      if (this.$hasPermission(80, true)) {
        return item.value !== 11;
      }
      return true;
    },
  },
  computed: {
    /**
     * 咨询老师
     */
    trainingTeachers() {
      return this.ds.training_teacher;
    },
    // 用户运营老师
    opTeachers() {
      return this.ds.op_teacher;
    },
    // 教务老师
    jwTeachers() {
      return this.ds.jw_teacher;
    },
    // 可以编辑意向分级
    notEditTrainingLvType() {
      // 160 考培组长
      return !this.$hasPermission([160]);
    },
    // 可以编辑介绍人编码,91考培总监,92考培教务主管,85考培主管,154市场中心
    canEditIntroducerId() {
      return !this.$hasPermission([80, 84, 85, 91, 92, 154, 157]);
    },
    /**
     * 创建人为是否为当前登录者可编辑
     */
    canEditByCreator() {
      if (this.isNew) {
        return true;
      }
      return this.userInfo.userid === Number(this.editData.creator);
    },
    /**
     * 只读类信息
     */
    infoReadonly() {
      if (this.$hasPermission([1])) {
        return false;
      }
      // 其他系统信息只读
      if (!this.isTrainingSite || this.isSnapshot) {
        return true;
      }
      // 路由信息匹配
      if (this.$route.meta.c === 'trainingreuse') {
        return true;
      }
      // 新资源
      if (this.isNew) {
        return false;
      }
      // 咨询老师是自己
      if (this.userInfo.userid === Number(this.editData.training_teacher)) {
        return false;
      }
      // 推广人是自己
      if (this.userInfo.userid === Number(this.editData.custom_promoter)) {
        // 117用户运营，只允许新增，不允许修改
        if (this.$hasPermission([117])) {
          return true;
        }
        return false;
      }
      // 84考培运营，85考培主管, 91考培总监, 52学生编辑组（产品运营）, 165微课主管
      if (this.$hasPermission([1, 84, 85, 91, 92, 52, 165])) {
        return false;
      }

      // if (!this.$hasPermission([81, 97, 117], true)) {
      //   return false;
      // }
      // if (this.$hasPermission([154, 81, 97, 117], true) && this.userInfo.userid === Number(this.editData.custom_promoter)) {
      //   return false;
      // }
      return true;
    },
    /**
     * 判断市场中心 154
     * @returns {boolean|*}
     */
    isMarketCenter() {
      return !this.isNew && this.$hasPermission([154], true) && this.userInfo.userid === Number(this.editData.custom_promoter);
    },
    /**
     * 特殊老师,可以修改电话和微信
     * 唐博考培管理（3707105）
     */
    isST() {
      return [3707105].indexOf(this.userInfo.userid) === -1;
    },
    /**
     * 修改咨询老师判断
     * @returns {boolean|*} 返回false，可修改，返回true 不可修改。
     */
    teacherModifyDisable() {
      // 新建资源可以修改咨询老师
      if (this.isNew) {
        return false;
      }

      // 管理员1，学生编辑组52，考培总监91，教务主管92，英澳培训总监139，考培主管85，考培咨询客服174 可以修改咨询老师
      if (this.$hasPermission([1, 52, 91, 92, 139, 85, 174])) {
        return false;
      }

      // 考培组长160 ，可以修改其组成员的咨询老师
      if (this.$hasPermission([160])) {
        return false;
      }

      // 1：角色是考培运营84 2：资源推广人是自己，3：分配老师必须是-考培待下发承接账号2819340 才可修改
      if (this.$hasPermission([84], true) && this.userInfo.userid === Number(this.editData.custom_promoter) && Number(this.editData.training_teacher) === 2819340) {
        return false;
      }

      // 以上都不是的不能修改
      return true;
    },
    // 格式化的计时器
    clinkFormattedCallTime() {
      let minutes = String(Math.floor(this.clinkCallTime / 60));
      let seconds = String(this.clinkCallTime % 60);
      if (minutes.length < 2) {
        minutes = `0${minutes}`;
      }
      if (seconds.length < 2) {
        seconds = `0${seconds}`;
      }
      return `${minutes}:${seconds}`;
    },
  },
  created() {
    this.isNew = this.$route.meta.isNew || false;
    this.$nextTick(() => {
      let isTeacher = false;
      this.getDatasource().then((data) => {
        isTeacher = data.originTrainingTeacher.some((t) => {
          return t.userid === this.userInfo.userid;
        });
        if (isTeacher && this.isNew) {
          // this.editData.target_country = ['1868']; // 默认选择考培
          this.editData.training_teacher = this.userInfo.userid;
        }
      });

      // ClinkAgent 登录
      console.info(this.userInfo);
      // if (this.userInfo.userid === 3118597 || this.userInfo.userid === 1) { // 董琳琳调试
      this.$http._get({
        url: '/index/clink/agentToken'
      }).then(({ data }) => {
        if (data.userid) {
          this.initClinkAgent(data.bindTel, data.agentToken);
        }
      });
    });
  },
  watch: {
    // 客户状态
    'editData.customer_status'(val) {
      if (val === 8 || val === 14) {
        this.followpUp = true;
      } else {
        this.followpUp = false;
      }
    },
    'editData.diff_type'(val) {
      if (val === 8) {
        this.otherDiff = true;
      } else {
        this.otherDiff = false;
      }
    },
  }
};
</script>

<style scoped>
  .bind{
    color: rgba(1, 13, 45, 1);
    font-size: 24px;
    display: inline-block;
    border-bottom: 4px solid rgba(1, 13, 45, 1);
    font-weight: bold;
    padding-bottom: 40px;
  }
  .webimlink {
    margin-left: 12px;
    padding: 4px 10px;
    background: #409eff;
    color: #fff;
    border-radius: 4px;
  }

  td:nth-child(odd) {
    word-break: keep-all;
  }

  .place {
    padding: 0 10px;
    background: #f3f3f3;
  }

  .basic-title {
    height: 35px;
    line-height: 35px;
    margin: 10px 8px 15px;
    position: relative;
    cursor: default;
    border-bottom: 1px solid #b8c4ce;
  }

  .basic-title em {
    display: block;
    float: left;
    width: 110px;
    height: 32px;
    font-size: 16px;
    line-height: 28px;
    text-indent: 8px;
    border-bottom: 4px solid #3368fa;
  }

  .basic-title em i {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-top: 6px;
    /* float: right; */
    margin-left: 8px;
    background-color: #3368fa;
    color: #fff;
    text-align: center;
    line-height: 15px;
    border-radius: 2px;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    text-indent: 0;
    vertical-align: middle;
    cursor: pointer;
  }

  .basic-table {
    width: 100%;
  }

  .basic-table th {
    padding: 3px 0;
    background-color: #e2eaf0;
    border-bottom: solid 1px #b8c4ce;
    cursor: pointer;
  }

  .basic-table th span {
    margin-left: 10px;
  }

  .basic-information {
    padding: 8px;
  }

  .basic-table th i {
    font-size: 14px;
    line-height: 26px;
  }

  .basic-table th i:after {
    display: inline-block;
    margin-left: 10px;
    content: "\e608";
  }

  .basic-table .el-row .el-col {
    display: flex;
    align-items: center;
    min-height: 55px;
    padding-left: 8px;
    border-right: solid 1px #b8c4ce;
    border-bottom: solid 1px #b8c4ce;
  }

  .basic-table-info .el-row:nth-child(2) .el-col {
    font-weight: bold;
  }

  .basic-table .scores-info .el-row .el-col {
    border-right: none;
    border-bottom: none;
    padding-left: 0;
  }

  .basic-table .scores-jmte {
    padding-left: 0 !important;
    border-bottom: none !important;
    border-right: none !important;
  }

  .mindMapping a {
    text-decoration: underline;
    color: #000;
  }

  .jm-span {
    display: inline-block;
    width: 80px;
    /* text-align: right; */
  }

  .basic-buttom {
    margin-top: 25px;
    text-align: center;
  }

  .title-bottom {
    float: right;
    margin: 0 20px;
  }

  .btn-send-msg {
    cursor: pointer;
  }

  .jm-studentEditBot {
    display: block;
    height: 100%;
    opacity: 1;
    margin-top: 3px;
  }

  .jm-tbody-hidden {
    display: none;
  }

  .el-collapse-item__header {
    background-color: #e2eaf0 !important;
  }

  .el-collapse-item {
    border-bottom: #b8c4ce solid 1px;
  }

  .edit-fixed {
    position: fixed;
    right: 70px;
    bottom: 256px;
    width: 35px;
    height: 35px;
    padding: 0;
    border-radius: 50%;
    text-align: center;
    z-index: 1;
    opacity: 0.7;
  }
</style>

<style>
  .diff_column input.el-input__inner {
    border-color: red;
  }

  .diff_column .el-select input.el-input__inner {
    border-color: red;
  }

  .basic-table-div .el-form-item__content {
    line-height: inherit !important;
  }
  .training-memo .el-textarea__inner{
    color: red;
    font-weight: bold;
  }
  .left10{
    margin-left: 10px;
  }
  .color-red{
    color: red;
  }
</style>
